import type { SchemaField, WalkFieldsOptions } from '@cli-types/core-engine/schema.js'
import { hasAnyFieldType } from './has-any-field-type.js'

export function hasFieldType(
  fields: SchemaField[],
  type: string,
  options?: WalkFieldsOptions
): boolean {
  return hasAnyFieldType(fields, [type], options)
}
